<template>
  <el-dialog
    top="150px"
    width="500px"
    class="upload-document"
    title="Chỉnh sửa thông tin tài liệu"
    :visible="visible"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClosePopup"
  >
    <el-form ref="form" :model="form" :rules="rules" label-position="top">
      <el-form-item label="Tên tài liệu" prop="name">
        <el-input v-model="form.name" :disabled="callingAPI" placeholder="Nhập vào tên tài liệu"></el-input>
      </el-form-item>
      <el-form-item label="Tác giả" prop="author">
        <el-input v-model="form.author" :disabled="callingAPI" placeholder="Nhập vào tên tác giả"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="callingAPI" @click="handleClosePopup">Hủy</el-button>
      <el-button type="primary" :loading="callingAPI" @click="handleUpdateDocument">Lưu</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { updateStorage } from '@/services/storage'

export default {
  name: 'UpdateDocument',
  props: {
    visible: Boolean,
    type: String,
    document: Object,
    object: Object
  },
  data() {
    return {
      callingAPI: false,
      form: JSON.parse(JSON.stringify(this.document || {})),
      rules: {
        name: [
          {
            required: true,
            message: 'Tên không được để trống.',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  watch: {
    document: {
      handler(val) {
        this.form = JSON.parse(JSON.stringify(val || {}))
      },
      deep: true
    }
  },
  methods: {
    handleUpdateDocument() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true
          updateStorage(this.form).then(() => {
            this.callingAPI = false
            this.$notify.success({
              title: 'Thông báo',
              message: 'Cập nhật tài liệu thành công.'
            })
            this.$emit('reload')
            this.$emit('close')
          }).catch(() => {
            this.callingAPI = false
            this.$notify.error({
              title: 'Thông báo',
              message: 'Không thể cập nhật tài liệu.'
            })
          })
        }
      })
    },
    handleClosePopup() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.upload-document {
  .card-document {
    width: 48%;
    box-sizing: border-box;
  }
}
</style>
